import { useCallback, useMemo } from 'react';
import { useFormik } from 'formik';

import { ADD_COHORT_FORM_INITIAL_VALUES } from '../constants/general';
import { addCohortFormSchema } from '../utils/validationSchema';
import useAddCohortFormSubmit from './useAddCohortFormSubmit';

import type { CohortFieldKeys } from '../constants/types/general';
import type { IOption } from '../../../../utils/types';

export default function useAddCohortForm() {
  const { submitAddCohortForm } = useAddCohortFormSubmit();
  const validationSchema = useMemo(() => addCohortFormSchema(), []);

  const formik = useFormik({
    initialValues: ADD_COHORT_FORM_INITIAL_VALUES,
    validationSchema,
    onSubmit: submitAddCohortForm,
  });

  const { values, setFieldValue, submitForm, errors, touched } = formik;

  const handleUpdateFieldValues = useCallback(
    (key: CohortFieldKeys, value: string | IOption[]) => {
      setFieldValue(key, value);
    },
    [setFieldValue],
  );

  return {
    formik,
    values,
    errors,
    touched,
    submitForm,
    handleUpdateFieldValues,
  };
}
